import { Box, Typography } from '@mui/material'
import { EmptySlotProps } from '../types'

export let EmptySlot = ({ message }: EmptySlotProps) => (
  <Box
    sx={{
      width: '100%',
      position: 'relative',
    }}
    role="status"
    aria-label={message}
  >
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio: '16/9',
        overflow: 'hidden',
        borderRadius: 2,
        bgcolor: 'rgba(255, 255, 255, 0.05)',
        border: '1px dashed',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography
        color="text.secondary"
        variant="body2"
        sx={{
          fontSize: 13,
        }}
        aria-hidden="true"
      >
        {message}
      </Typography>
    </Box>
  </Box>
)
